@let entities =
  processEc.plugins.currentListPlugin.feature.selectors.entities.asSignal();
@let isLoading =
  processEc.plugins.currentListPlugin.feature.selectors.isLoading.asSignal();
@let error =
  processEc.plugins.currentListPlugin.feature.selectors.error.asSignal();
@let isPollingStarted = pollingPlugin.feature.selectors.isStarted.asSignal();

<div class="atn-process-list">
  @if (error) {
    <div class="atn-process-list__empty-state-container">
      <div class="atn-process-list__empty-state-content">
        <atn-ds-empty-state
          description="An error occurred while loading the processes. Please try again."
          layout="v"
          title="No processes available"
          type="error"
          (action)="refreshProcessesHandler('ErrorState')"
        />
      </div>
    </div>
  } @else if (isLoading && !isPollingStarted) {
    <!-- NOTE: Show loader only when initial loading occurs (polling not
       started) to prevent UI flickering during periodic polling refreshes -->
    <div class="atn-process-list__loader">
      <div class="atn-process-list__loader-spinner"></div>
    </div>
  } @else if (entities.length) {
    @for (process of processesSg(); track $index) {
      <atn-process [process]="process" />
    }
  } @else {
    <div class="atn-process-list__empty-state-container">
      <div class="atn-process-list__empty-state-content">
        <atn-ds-empty-state
          description="No processes available for this tenant, in this zone."
          layout="v"
          title="No processes available"
          type="no-data"
          (action)="refreshProcessesHandler('EmptyState')"
        />
      </div>
    </div>
  }
</div>
